





















































































































































































































































































































































































































































import _, {cloneDeep} from 'lodash';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {DxButton, DxScrollView, DxTextBox} from 'devextreme-vue';
import TableGrid from '@/components/TableGrid/grid.vue';
import DButton from '@/components/DButton/button.vue';
import DSelectbox from "@/components/DSelectbox/selectbox.vue";
import DxSelectBox from 'devextreme-vue/select-box';
import DTextbox from "@/components/DTextbox/textbox.vue";
import DNumberbox from "@/components/DNumberbox/numberbox.vue"
import {DxCheckBox} from "devextreme-vue/check-box";
import {
  YearType,
  CutType,
  Tariff,
  EcoObjectType,
  FilialNodeTreeExtended,
  FilialExtended,
  EcoFilialSelectionType,
  EcoNodeSelectionType,
} from "@/services/models-service";
import YearService from "@/services/years-service";
import CutService from "@/services/cut-service";
import TariffService from "@/services/tariff-service";
import {DxValidationGroup} from 'devextreme-vue';
import {confirm} from "devextreme/ui/dialog";
import {view_tarif, sign_internal_turnover, value_group, value_group_vgo, periods, sort_property_tariff, months_map} from "@/constants";
import TariffPopup from "@/views/tarifs/components/tariff-popup.vue";
import TariffHistoryPopup from "@/views/tarifs/components/tariff-history-popup.vue";
import ShareService from "@/services/share-service";
import HeatCarrierService, {HeatCarrier} from '@/services/data/heat_carrier_service';
import {v4 as uuidv4} from 'uuid';
import EcoObjectsService  from "@/services/eco-objects-service";
import UserAccessService from '@/services/user_access_service';
import AuthService from '@/services/auth_service';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import UserManagerService from "@/services/data/user_manager";
import WebSocketService from '@/services/websocket_service';
import {format2DigitsVariant, format2DigitsVariantNotUseGrouping} from "@/utils/numbers";
import { alert } from 'devextreme/ui/dialog';
import dicts_cache_service from "@/services/dicts_cache_service";
import AnimatePopup from '@/components/AnimatePopup/animate-popup.vue';
import ExcelPasteHint from '@/components/ExcelPasteHint/index.vue';
import TreeDropDownBox from "@/components/TreeDropDownBox/tree-drop-down-box.vue";
import TreeDropDownBoxSingleCheck from "@/components/TreeDropDownBox/tree-drop-down-box-single-check.vue";
import { isEqual } from 'lodash';

interface EcoFacilitySelectionType {
  id: number;
  name: string;
  check: boolean;
}

@Component({
  name: 'Tariff',
  components: {
    TreeDropDownBoxSingleCheck,
    DxButton,
    DxTextBox,
    TableGrid,
    DxScrollView,
    DButton,
    DSelectbox,
    DxSelectBox,
    DxCheckBox,
    DTextbox,
    DNumberbox,
    DxValidationGroup,
    TariffPopup,
    TariffHistoryPopup,
    DxLoadPanel,
    AnimatePopup,
    ExcelPasteHint,
    TreeDropDownBox
  }
})

export default class extends Vue {

  public auth_service = AuthService;
  public cut_service = CutService;

public hint = 'Цена/тариф используется, нельзя редактировать';
public current_year: any = '';
public current_cut: any = '';
public current_filial: number | null = null;
public current_node: number | null = null;
public columns: Array<any> = [];
public all_years: YearType [] = [];
public all_filials: EcoObjectType [] = [];
public all_filials_tree: any = [];
public all_nodes: EcoObjectType [] = [];
public facilityByCurrentNode: EcoObjectType [] = [];
public tariffs: Tariff[] = [];
public cuts: CutType[] = [];
public strong_tariff_calc: boolean | null = false;
public allHeatCarrier: HeatCarrier[] = [];
private tariff_service = TariffService;
public view_tarif = view_tarif;
public sign_internal_turnover = sign_internal_turnover;
public value_group = value_group;
public value_group_vgo = value_group_vgo;
public sort_property_tariff = sort_property_tariff;
public target_tariffs: Tariff[] = [];
public tariffsData: any[] = [];
public oldTariffsData: any[] = [];  // Хранение пердыдущего состояния tariffsData 
                                    // Возможно это не очень оптимально с точки зрения памяти
public tariffsDataMirror: any[] = [];
public isChangeData: boolean = false;
public gettedTariffs: boolean = false;
public newTarrifCount: number = 0;
public tariffPopup: any = {
    visible: false,
}

public isSorting: boolean = false;

public sort_property:any = {
  view: { active : false, down: false},
  sign_internal_turnover: { active : false, down: false},
  value_group: { active : false, down: false},
  id_heat_carrier: { active : false, down: false},
  description: { active : false, down: false}
}

  public type = {tariff: 'tariff', index: 'index'};

  public warmEnergyArray: any[] = [];

  public shareService = ShareService;

  public blockCalc: boolean = false;

  public tariffHistoryPopup: any = {
    visible: false,
  }

  public isLoad: boolean = false;
  private ls_key: string = 'tariffs_filter';
  private saved_filters: any = {
    year_id: null,
    cut_id: null,
    filial_id: null,
    heat_node_id: null,
  }

  private permission_nodes: any[] = [];
  public allowEditTariff: boolean = false;
  public disableSelector: boolean = false;

  public loading_animation: boolean = false;
  public first_step_loading: boolean = false;

  // флаг блокировки onChange функций
  public blockOnChange: boolean = false;

  // Свойства для Excel paste функциональности
  public showExcelHint: boolean = false;
  public globalPasteData: number[][] | null = null;
  public globalPasteStartRow: number = 0;
  public globalPasteStartCol: number = 0;
  public globalPasteTargetTariff: number | null = null;

  public cutsDataChanged: boolean = true

  public isNewRowAdded: boolean = false

  get route() {
    return this.$route.name
  }

  public isSave:boolean = false;
  public get copyAnimatePopupOptions() {
    return {
      visible: this.isSave,
      text: 'Выполняется обновление тарифов и пересчет стоимости...'
    }
  }

  public show_pao_tplus = false;
  public oneActiveCheck = true;
  public selectionData: EcoFilialSelectionType[] = [];








  get canLoadData(): boolean {
    return !!(this.current_cut && this.current_node && this.isLoad);
  }

  async onLoadData() {
    if (this.isChangeData || this.newTarrifCount > 0) {
      const message = this.newTarrifCount > 0 
        ? 'Имеются несохранённые новые тарифы. Сохранить?' 
        : 'Имеются несохранённые изменения. Сохранить?';
      
      confirm(message, 'Сохранение')
        .then((answer: boolean) => {
          if (answer) {
            this.onSave();
          } else {
            this.newTarrifCount = 0;
            this.loadTariffData();
          }
        });
    } else {
  await this.loadTariffData();
  this.$nextTick(() => {
    this.cutsDataChanged = false;
    this.isSaveButtonDisabled = true
  });
}
}


  // В data или computed
public months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

// Метод для получения названия месяца
getMonthName(index: number): string {
  const monthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
  return monthNames[index] || '';
}

  onHierarchyChanged({ filials, nodes, facilities }: {
    filials: number[];
    nodes: number[];
    facilities: number[];
  }) {
    const val = nodes[0] ?? null;
    if (val === this.current_node) {
      this.current_node = null;
      this.$nextTick(() => { this.current_node = val; }); // два изменения подряд → watcher сработает
    } else {
      this.current_node = val;
    }
    this.saveFilters();
  }

  async getFilialsNodesTree() {
    // Проверяем, что выбраны год и срез
    if (!this.current_year || !this.current_cut) {
      return;
    }

    // Находим объекты года и среза
    const year = this.all_years.find((y: YearType) => y.id === this.current_year);
    const cut  = this.cuts.find((c: CutType)   => c.id === this.current_cut);
    if (!year || !cut) {
      return;
    }

    // Формируем множество разрешённых филиалов для текущего пользователя
    const allowedFilials = new Set<number>();
    for (const key in UserAccessService.userAccessDS) {
      allowedFilials.add(+key);
    }

    // Узнаём текущий маршрут и список доступных узлов
    const route = this.$route.name;
    this.permission_nodes = route
      ? UserAccessService.checkReading(route)
      : [];

    // Запрашиваем расширённое дерево филиалов
    const response = await EcoObjectsService.filial_nodes_tree_extended(cut.id_eco_version, year.name, null);

    if (!response.data) {
      this.selectionData = [];
      return;
    }

    // Клонируем, чтобы не мутировать оригинал
    const tree = _.cloneDeep(response.data);

    // Собираем структуру selectionData
    const selectionData: EcoFilialSelectionType[] = [];

    for (const filialKey in tree) {
      const filialEntry = tree[Number(filialKey)];
      const filialId    = filialEntry.filial.id;

      // Пропускаем, если нет доступа к филиалу (и пользователь не админ)
      if (!this.auth_service.isAdmin() && !allowedFilials.has(filialId)) {
        continue;
      }

      // Собираем массив узлов с пустым полем facilities
      const nodes: EcoNodeSelectionType[] = [];

      for (const nodeKey in filialEntry.nodes) {
        const node = filialEntry.nodes[Number(nodeKey)];

        // Фильтруем по правам чтения
        if (this.permission_nodes.indexOf(node.id) === -1) {
          continue;
        }

        // Иначе — просто пустой массив
        const facilities: EcoFacilitySelectionType[] = [];

        const check = node.id === this.saved_filters.heat_node_id;

        nodes.push({
          id:         node.id,
          name:       node.name,
          check:      check,
          facilities: facilities
        });
      }

      // Добавляем только если есть хотя бы один доступный узел
      if (nodes.length) {
        selectionData.push({
          id:    filialId,
          name:  filialEntry.filial.name,
          check: false,
          nodes: nodes
        });
      }
    }

    // Сохраняем и даём компоненту нужную форму данных
    this.selectionData = selectionData;
  }

  checkDescription(data: any, tariffsData:any) {
    return function() {
      let result = true;
      const match = tariffsData.find((tariff_data: any) => tariff_data.tariff.description.trim() === data.tariff.description.trim() && tariff_data.tariff.id !==  data.tariff.id);
      if(match) result = false;
      return result
    };
  }

  async created() {
    if (this.$options.sockets) {
      this.$options.sockets.onmessage = (data: any) => {
        let res = WebSocketService.handleMsg(data, 'finish_recalc_after_tariff');
        if (!_.isNil(res)) {
          this.isSave = false;
        }
      }
    }

    let indx = 0;
    // шаблон {tariff: "january_we", index: "index_january_we", order: 0, tariff_wp: "january_wp", index_wp: "index_january_wp"},
    for (let p of periods) {
      this.warmEnergyArray.push({
        order: indx,
        tariff: `${p}_we`,
        index: `index_${p}_we`,
        tariff_wp: `${p}_wp`,
        index_wp: `index_${p}_wp`
      });
      indx++;
    }

    this.isLoad = false;

    this.loadFilters();

    this.all_years = YearService.filteredYearList;

    if (this.saved_filters.year_id) {
      this.current_year = this.saved_filters.year_id;
    } else {
      this.current_year = YearService.current?.id;
    }

    await this.getCutsYear();

    if (this.saved_filters.cut_id) {
      this.current_cut = this.saved_filters.cut_id;
    }

    await Promise.all([this.getFilialsTree(), this.getHeatCarrier(), this.getFilialsNodesTree()])

    if (!_.isNil(this.saved_filters.filial_id)) {
      this.current_filial = this.saved_filters.filial_id;

      this.all_nodes = this.all_filials_tree[`${this.current_filial}`];

      if (this.saved_filters.heat_node_id) {
        this.current_node = this.saved_filters.heat_node_id;
      }
    }

    if(this.route) {
      this.permission_nodes = UserAccessService.checkReading(this.route);
    }

    const current = this.permission_nodes.find((node: number) => node === this.saved_filters.heat_node_id);

    if(!current) {
      this.current_node = null;
      this.saved_filters.heat_node_id = null;
    }

    this.loadTariffData();
    

    setTimeout(() => {
      this.isLoad = true;
      this.current_node = JSON.parse(localStorage.getItem('facility_save') || '{}')?.singleSelected?.nodeId ?? null;
    }, 500)

  }

  async mounted() {
    if ((!this.current_cut || !this.current_node) && !this.isLoad) {
      await this.ensureDataLoaded();
    } else if (this.current_cut && this.current_node && this.tariffsData.length === 0) {
      await this.loadTariffData();
    }
  }

  async activated() {
    if ((!this.current_cut || !this.current_node) && !this.isLoad) {
      await this.ensureDataLoaded();
    } else if (this.current_cut && this.current_node && this.tariffsData.length === 0) {
      await this.loadTariffData();
    }
  }

  async ensureDataLoaded() {
    if (this.isLoad) {
      return;
    }

    this.isLoad = false;
    this.loadFilters();
    this.all_years = YearService.filteredYearList;

    if (this.saved_filters.year_id) {
      this.current_year = this.saved_filters.year_id;
    } else {
      this.current_year = YearService.current?.id;
    }

    await this.getCutsYear();

    if (this.saved_filters.cut_id) {
      this.current_cut = this.saved_filters.cut_id;
    }

    await Promise.all([this.getFilialsTree(), this.getHeatCarrier(), this.getFilialsNodesTree()]);

    if (!_.isNil(this.saved_filters.filial_id)) {
      this.current_filial = this.saved_filters.filial_id;
      this.all_nodes = this.all_filials_tree[`${this.current_filial}`];

      if (this.saved_filters.heat_node_id) {
        this.current_node = this.saved_filters.heat_node_id;
      }
    }

    if (this.route) {
      this.permission_nodes = UserAccessService.checkReading(this.route);
    }

    const current = this.permission_nodes.find((node: number) => node === this.saved_filters.heat_node_id);

    if (!current) {
      this.current_node = null;
      this.saved_filters.heat_node_id = null;
    }

    if (this.current_cut && this.current_node) {
      await this.loadTariffData();
    }

    setTimeout(() => {
      this.isLoad = true;
      this.current_node = JSON.parse(localStorage.getItem('facility_save') || '{}')?.singleSelected?.nodeId ?? null;
    }, 500);
  }

  async loadTariffData() {
  if (!this.current_cut || !this.current_node) {
    return;
  }
  this.getNodeFacilities();
  await this.getTariffs();

  this.isChangeData = false;

  this.newTarrifCount = 0; // Сбрасываем счётчик после загрузки
  this.$nextTick(() => {
    this.cutsDataChanged = false
  })
}


  formatReadOnlyValue(val: number) {
    return this.$options.filters?.numberFormat(val, 2) || format2DigitsVariantNotUseGrouping.format(val);
  }

  async getFilialsTree() {

    if (!this.current_year || !this.current_cut) {
      return
    }

    const year = this.all_years.find((y: YearType) => y.id === this.current_year);
    const cut = this.cuts.find((c: CutType) => c.id === this.current_cut);

    if (!year || !cut) {
      return
    }
    let allowed_filials_ids = new Set();
    for (let key in UserAccessService.userAccessDS) {
      allowed_filials_ids.add(+key)
    }

    let route = this.$route.name
    if (route) {
      this.permission_nodes = UserAccessService.checkReading(route);
    }

    this.all_filials = [];
    this.all_filials_tree = {};
    const response = await EcoObjectsService.filial_nodes_tree_extended(cut.id_eco_version, year.name, null);

    if (response.data) {

      const filials_tree: FilialNodeTreeExtended = _.cloneDeep(response.data);
      for (let filial_uid in filials_tree) {
        const filial: FilialExtended = filials_tree[Number(filial_uid)];
        const filial_id: string = `${filial.filial.id}`;
        if (!this.auth_service.isAdmin() && !allowed_filials_ids.has(filial.filial.id)) {
          continue
        }

        this.all_filials_tree[filial_id] = [];
        for (let node_uid in filial.nodes) {
          const node = filial.nodes[Number(node_uid)];
          if (this.permission_nodes.indexOf(node.id) !== -1) {
            this.all_filials_tree[filial_id].push(node)
          }
        }

        if (this.all_filials_tree[filial_id].length > 0) {
          this.all_filials.push(filial.filial);
        }

      }
    }

  }

  async getCutsYear() {
    const response = await this.cut_service.getWithFilter(this.current_year);
    if (response.data) {
      const cuts_resp = _.sortBy(response.data, [(o) => o.number]);
      this.cuts =  cuts_resp.filter((c) => c.visible_for === 'Видимый для администратора' || c.visible_for === 'Видимый для всех');
    }
  }

  async getHeatCarrier() {
    if (!HeatCarrierService.local.length) {
      await HeatCarrierService.storeLocal();
    }
    this.allHeatCarrier = HeatCarrierService.local;
  }

  get allFiltersSelected() {
      return this.current_cut && this.current_node;
  }

  async getTariffs() {
    if (this.current_cut && this.current_node && this.route) {
      this.loading_animation = true;
      this.first_step_loading = true;
      this.gettedTariffs = true;
      this.allowEditTariff = UserAccessService.checkEditingTariff(this.route, this.current_node);

      const response = await this.tariff_service.getWithFilter(this.current_cut, this.current_node);

      if (response.data) {

        this.setBlock();

        this.tariffs = response.data;
        this.tariffs = this.tariffs.sort((a:Tariff, b: Tariff):number => {
          const result = this.compare(a.id_heat_carrier,b.id_heat_carrier);
          if (result === 0) {
            const res = this.compare(a.value_group,b.value_group);
            if (res === 0) {
              const final_res = this.compare(a.description,b.description);
              return final_res
            } else {
              return res
            }
          } else {
            return result
          }
        });
        this.tariffsDataMirror = [];
        let newData: any[] = [];
        let count = 1;
        this.tariffs.forEach((t:Tariff) => {
          t.edit_fields = null;
          t.edit_fields = {te: new Set(), power: new Set()};

          const data = {
            isSelect: false,
            isNew: false,
            isFocus: false,
            isEdit: false,
            order: count,
            tariff: _.clone(t)
          }
          newData.push(data);
          this.tariffsDataMirror.push({
            isEditReady: false,
            order: count,
            inputsReady: {}
          })
          count += 1;
        })

        newData.sort((a: any, b: any) => a - b);
        this.tariffsData = newData;
        this.oldTariffsData = _.cloneDeep(this.tariffsData)
        this.isChangeData = false;

        this.loading_animation = false;
        this.$forceUpdate();

        Vue.nextTick(() => {
          setTimeout(() => {
            this.gettedTariffs = false;
            this.first_step_loading = false;
            this.unBlock();
          }, 10);
        })
      }
    }
  }

  compare(a:any, b:any) {
    if ((a || '') === (b || '')) return 0;
    if ((a || '') > (b || '')) return 1;
    if ((a || '') < (b || '')) return -1;
    return 0;
  }

  reverseCompare(a:any, b:any) {
    if ((a || '') === (b || '')) return 0;
    if ((a || '') < (b || '')) return 1;
    if ((a || '') > (b || '')) return -1;
    return 0;
  }

  sortTariffs(property: string) {
    this.isSorting = true;
    this.blockOnChange = true;
    if (this.sort_property[property].active) {
      for (let key in this.sort_property) {
        if (key !== property) {
          this.sort_property[key].active = false;
          this.sort_property[key].down = false;
        }
      }
      if (this.sort_property[property].down) {
        this.sorting(property, this.reverseCompare);
        this.sort_property[property].down = false;
      } else {
        this.sorting(property, this.compare);
        this.sort_property[property].down = true;
      }
    } else {
      for (let key in this.sort_property) {
        if (key !== property) {
          this.sort_property[key].active = false;
          this.sort_property[key].down = false;
        }
      }
      this.sorting(property, this.compare);
      this.sort_property[property].active = true;
      this.sort_property[property].down = true;
    }

    this.$nextTick(() => {
      this.isSorting = false;
      this.blockOnChange = false;
      this.tariffsData.forEach((data: any) => {
        data.isSelect = false;
      });
      this.isSaveButtonDisabled = true;
      this.isChangeData = false;
    })

  }

  sorting(property: string, funcSort: Function) {
    this.tariffs = this.tariffs.sort((a:any, b: any):number => {
      return funcSort(a[property],b[property])
    });
    this.tariffsData = this.tariffsData.sort((a:any, b:any):number => {
      return funcSort(a.tariff[property],b.tariff[property]);
    });
    const newTariffsDataMirror: any[] = [];
    this.tariffsData.forEach((data:any) => {
      const match = this.tariffsDataMirror.find((t:any) => t.order === data.order);
      if (match) newTariffsDataMirror.push(match);
    })
    this.tariffsDataMirror = newTariffsDataMirror;
    this.oldTariffsData = _.cloneDeep(this.tariffsData);
  }

  setBlock() {
    // блокировка запуска циклического пересчета
    this.blockCalc = true;
  }

  unBlock() {
    // снятие блокировки пересчета
    setTimeout(() => {
      this.blockCalc = false;
    }, 500);
  }

  onAdd() {
    this.blockOnChange = true;
    this.isChangeData = true
    const new_tariff = new Tariff();
    new_tariff.id_cut = this.current_cut;
    new_tariff.id_eco_heat_node = this.current_node;
    new_tariff.edit_fields = {te: new Set(), power: new Set()};

    this.setBlock();

    const tempUuid = uuidv4();
    this.tariffsData.unshift({
      tempUuid: uuidv4(),
      isSelect: true,
      isNew: true,
      isFocus: false,
      isEdit: false,
      count: this.tariffsData.length + 1,
      tariff: new_tariff
    })
    this.tariffsDataMirror.unshift({
      isEditReady: true,
      count: this.tariffsDataMirror.length + 1,
      inputsReady: {}
    })
    this.newTarrifCount += 1;
    this.isNewRowAdded = true

    const element: any = this.$refs.tariff_row0;
    this.$nextTick(() => {
      if (element?.length) {
        element.focus();
      }

    });
    document.addEventListener('click', this.seekFocus);
    this.unBlock();
    this.$nextTick(() => {
      setTimeout(()=>{
        this.blockOnChange = false;
      }, 500)
    });
  }

  async onSave() {
    if (this.isChangeData) {
    const vg = (this.$refs['tariffForm'] as any).instance;
    const result = vg.validate();
    if (result.isValid) {
      const invalidTariffs: string[] = [];

      for (let data of this.tariffsData.filter((data: any) => data.isSelect || data.isNew)) {
        if (data.tariff.sign_internal_turnover !== "ВГО" && data.tariff.sign_internal_turnover !== "ВНО") {
          const hasCollectorsOrHeatingSystem: boolean = data.tariff.collectors || data.tariff.heating_system;
          const hasRevenueOrCosts: boolean = data.tariff.revenue || data.tariff.expenses;
          if (!hasCollectorsOrHeatingSystem || !hasRevenueOrCosts) {
            invalidTariffs.push(data.tariff.description);
          }
        }
      }
      if (invalidTariffs.length > 0) {
        const tariffList: string = invalidTariffs.join(', ');
        await alert(
          `Для тарифов "${tariffList}" без признака внутреннего оборота необходимо выбрать хотя бы один признак из каждой пары свойств:\n\n1. "С коллекторов" или "Из теплосети"\n2. "Выручка" или "Затраты"`,
          'Ошибка валидации'
        );
        return;
      }
        this.isSave = false;
      document.removeEventListener('click', this.seekFocus);
      try {
        const onSaveTariff: Tariff[] = [];
        this.tariffsData.forEach((data: any) => {
          if (data.isSelect || data.isNew) {
            data.tariff.edit_fields.te = Array.from(data.tariff.edit_fields.te);
            data.tariff.edit_fields.power = Array.from(data.tariff.edit_fields.power);
            data.tariff.edit_fields = JSON.stringify(data.tariff.edit_fields);
            data.tariff.instance_id = data.tariff.instance_id;
            onSaveTariff.push(data.tariff);
          }
        })
        if (onSaveTariff.length > 0) {
          await this.tariff_service.save(onSaveTariff);
        }
        this.tariffsData.forEach((data: any) => {
          data.isEdit = false;
          data.isNew = false;
          data.isSelect = false;
        });
        this.loadTariffData();
        this.target_tariffs = [];
        this.newTarrifCount = 0;
      } catch (e) {
        console.error('Ошибка при сохранении тарифов:', e);
      }
    } else {
      return;
    }
  } else {
    return;
  }
  this.isSaveButtonDisabled = true
}
  async onRemove() {
    const tariffs = this.target_tariffs.map((t:Tariff) => {
      t.edit_fields = null;
      return t;
    })
    await this.tariff_service.delete(tariffs);
    await this.getTariffs();
    this.target_tariffs = [];
  }

  cancelEditData(data: any) {
    if (data.isNew) {
      confirm('Вы хотите отменить отменить изменения. Отменить?', 'Отмена')
        .then((answer: boolean) => {
          if (answer) {
            this.blockOnChange = true;
            document.removeEventListener('click', this.seekFocus);
            this.tariffs.shift();
            this.tariffsData.shift();
            this.tariffsDataMirror.shift();
            this.oldTariffsData.shift();
            this.newTarrifCount -= 1;
            this.$nextTick(()=>{
              this.blockOnChange = false;
            })
          }
        });
    }
  }

  seekFocus(e: any) {
    const element: any = this.$refs.tariff_row0;
    if (!element.contains(e.target)) {
      element.focus();
    }
  }

  onOpenEditor() {
    this.tariffPopup.visible = true;
  }

  onOpenLog() {
    this.tariffHistoryPopup.visible = true;
  }


  onOpened(e: any) {
    // this.haveEditData();
  }

  empty() {
    //
  }

get nodeObjectsIds() {
  // возвращает массив uid объектов текущего ТУ
  return this.facilityByCurrentNode?.map(item => item.id) || [];
}

public isSaveButtonDisabled: boolean = true

get tariffsList() {
  return this.tariffsData.map(item => item.tariff);
}

@Watch('tariffsList', {deep: true})
onTariffChanged(newVal: any, oldVal: any) {
  if (this.isSorting) {
    return;
  }
  if (!isEqual(this.tariffsData, this.oldTariffsData)) {
    this.isSaveButtonDisabled = false;
    console.log("tariff changed", {main: this.tariffsData, old: this.oldTariffsData})
  } else {
    this.isSaveButtonDisabled = true;
  }
  
}

markChangedTariff(index: any){
  console.log('select index: ', index)
  if (!isEqual(this.tariffsData[index], this.oldTariffsData[index]) && (!this.isNewRowAdded || this.tariffsData[index].isNew)){
    this.tariffsData[index].isSelect = true
  } else {
    this.tariffsData[index].isSelect = false
  }
  this.$nextTick(() => {
    this.isNewRowAdded = false
  })

}

@Watch('cut_service.acceptIsChanged')
  async reloadData(): Promise<void> {
  if (!this.cut_service.acceptIsChanged || !this.isLoad) {
    return;
  }

  const objectKeys = Object.keys(this.cut_service.acceptChanges?.data || {});
  const hasTariff = this.nodeObjectsIds.some(id =>
    objectKeys.includes(String(id)) &&
    Object.keys(this.cut_service.acceptChanges?.data[id] || {}).some(key =>
        key.endsWith('__tariff')
    )
  );

  if (hasTariff) {
    await alert(`Было произведено акцептирование тарифов для текущего ТУ, будет выполнена перезагрузка`, 'Внимание');
    if (this.isChangeData) {
      this.haveEditData();
    } else {
      this.loadTariffData();
    }
  }
}

@Watch("current_year")
async changeYear() {
    if (!this.isLoad) {
      return;
    }
    this.cutsDataChanged = true

    await this.getCutsYear();
    this.current_cut = '';
    
    // Обновляем дерево узлов при смене года
    await this.getFilialsNodesTree();
    
    this.shareService.share_year_id = this.current_year;
    this.saveFilters();
}


@Watch("current_filial")
async changeFilial() {
  console.log(this.current_filial)
  if (!this.isLoad) {
    return;
  }
  this.cutsDataChanged = true


  this.current_node= null;
  this.shareService.share_filial_id = this.current_filial;
  this.saveFilters();

  this.all_nodes = [];
  if (this.current_filial) {
    this.all_nodes = this.all_filials_tree[`${this.current_filial}`]
  }

}


  @Watch("current_cut")
async changeCut() {
  console.log(this.current_cut)
  if (!this.isLoad) return;
  
  // Проверяем несохранённые изменения перед сменой срезки
  if (this.isChangeData || this.newTarrifCount > 0) {
    const message = this.newTarrifCount > 0 
      ? 'Имеются несохранённые новые тарифы. Продолжить смену срезки без сохранения?' 
      : 'Имеются несохранённые изменения. Продолжить смену срезки без сохранения?';
    
    const answer = await confirm(message, 'Предупреждение');
    if (!answer) {
      // Отменяем смену срезки - возвращаем предыдущее значение
      const prevCut = this.saved_filters.cut_id;
      this.$nextTick(() => {
        this.blockOnChange = true;
        this.current_cut = prevCut;
        this.$nextTick(() => {
          this.blockOnChange = false;
        });
      });
      return;
    }
  }
  
  this.cutsDataChanged = true;
  this.blockOnChange = true;
  
  try {
    if (this.current_cut) {
      await Promise.all([this.getFilialsTree(), this.getFilialsNodesTree()]);
    } else {
      this.current_filial = null;
      this.current_node = null;
    }
    
    this.shareService.share_cut_id = this.current_cut;
    this.shareService.share_heat_node_id = this.current_node;
    this.saveFilters();

    this.tariffsData = [];
    this.tariffs = [];
    this.isChangeData = false;
    this.newTarrifCount = 0; // Сбрасываем счётчик новых тарифов
  } finally {
    this.$nextTick(() => {
      this.blockOnChange = false;
      this.isChangeData = false;
      this.loadTariffData();
    });
  }
}



get monthsList() {
  // возвращает массив месяцев от 1 до 12
  return Array.from({length: 12}, (_, i) => i + 1);
}

async getNodeFacilities(): Promise<void> {
  // получение объектов текущего ТУ
  if (!this.current_year || !this.current_cut || !this.current_node) {
    return;
  }

  const year = this.all_years.find((y:YearType) => y.id === this.current_year);
  const cut = this.cuts.find((c:CutType) => c.id === this.current_cut);
  if (cut){
    this.strong_tariff_calc = cut.strong_tariff_calc
  }
  
  if (!cut || !cut.id_eco_version || !year) {
    return;
  }

  const response = await EcoObjectsService.get_facilities(cut.id_eco_version, this.current_node, null, year.name, this.monthsList);
  if (response?.data) {
    this.facilityByCurrentNode = response?.data;
  }
}

@Watch("current_node", {deep: true})
async changeContractorList() {
  console.log("node", this.current_node)
  if (!this.isLoad) {
    return;
  }
  
  // Проверяем несохранённые изменения перед сменой узла
  if ((this.isChangeData || this.newTarrifCount > 0) && !this.blockOnChange) {
    const message = this.newTarrifCount > 0 
      ? 'Имеются несохранённые новые тарифы. Продолжить смену теплового узла без сохранения?' 
      : 'Имеются несохранённые изменения. Продолжить смену теплового узла без сохранения?';
    
    const answer = await confirm(message, 'Предупреждение');
    if (!answer) {
      // Отменяем смену узла - возвращаем предыдущее значение
      const prevNode = this.saved_filters.heat_node_id;
      this.blockOnChange = true;
      this.$nextTick(() => {
        this.current_node = prevNode;
        this.$nextTick(() => {
          this.blockOnChange = false;
        });
      });
      return;
    }
  }

  this.cutsDataChanged = true;
  this.blockOnChange = true;

  this.shareService.share_heat_node_id = this.current_node;
  this.saveFilters();

  this.tariffsData = [];
  this.tariffs = [];
  this.isChangeData = false;
  this.newTarrifCount = 0; // Сбрасываем счётчик новых тарифов
  
  this.$nextTick(() => {
    this.blockOnChange = false;
    this.isChangeData = false;
    this.loadTariffData();
  });
}






/*

  Уже готовый вотчер был дополнен логикой сравнения текущих изменений с загруженными при обновлении
  На основании этого он меняет значение this.isChangeData, что и влияет на вид и исполнение кнопки "Сохранить"

*/




@Watch("tariffsData", { deep: true })
checkChanges() {

  /*
  console.log(
    JSON.parse(JSON.stringify(this.tariffsDataMirror)) == JSON.parse(JSON.stringify(this.tariffsData)),
    JSON.parse(JSON.stringify(this.tariffsDataMirror)),
    JSON.parse(JSON.stringify(this.tariffsData))
  )
  

  console.log(
    !this.gettedTariffs && !this.isSorting && !this.blockOnChange,
    !this.gettedTariffs,
    !this.isSorting,
    !this.blockOnChange,
    !this.isChangeData,

    !(this.oldTariffsData.length > 0),
    this.oldTariffsData,
    this.oldTariffsData.length

  )

  */

  if (!this.gettedTariffs && !this.isSorting && !this.blockOnChange) {




      if (this.oldTariffsData.length > 0){    // tariffsDataMirror потенциально может быть []

        //map нужен чтобы убрать параметр выделения элемнта, т.к. он по факту ничего не изменяет в данных (наверное)
        const currentClean = this.$data.tariffsData.map(({ isSelect, ...rest }: any) => rest);
        const oldClean = this.$data.oldTariffsData.map(({ isSelect, ...rest }: any) => rest);

        // console.log( "data сравнения", currentClean, oldClean )
        
        this.isChangeData = JSON.stringify(currentClean) !== JSON.stringify(oldClean);


      }


  }
}









changeValueGroup(data: any, e: any) {
  if (this.gettedTariffs || this.blockOnChange) {
    return
  }
  data.isEdit = true;
  if (data.tariff.sign_internal_turnover === "ВНО") {
    data.tariff.value_group = "Прочие";
    data.tariff.collectors = false;
    data.tariff.heating_system = false;
    data.tariff.expenses = false;
    data.tariff.revenue = false;
  }
  if (data.tariff.sign_internal_turnover === "ВГО") {
    data.tariff.value_group = "Прочие";
    data.tariff.collectors = false;
    data.tariff.heating_system = false;
    data.tariff.expenses = false;
    data.tariff.revenue = false;
  }
}

changeCollector(data: any) {
  if (this.gettedTariffs || this.blockOnChange) {
    return
  }
  data.isEdit = true;
  if (data.tariff.value_group === "Сторонние поставщики" && !data.tariff.sign_internal_turnover) {
    data.tariff.expenses = true;
  }
  if (data.tariff.value_group === "Сторонние поставщики" || data.tariff.value_group === "Транспорт") {
    data.tariff.collectors = false;
  }
  if (data.tariff.value_group !== "Сторонние поставщики" && data.tariff.value_group !== "Транспорт" &&  data.tariff.collectors && !data.tariff.sign_internal_turnover) {
    data.tariff.revenue = true;
  }
  if (data.tariff.value_group !== "Сторонние поставщики" && data.tariff.value_group !== "Транспорт" &&  data.tariff.heating_system && !data.tariff.sign_internal_turnover) {
    data.tariff.revenue = true;
  }
  if (data.tariff.value_group === "Сторонние поставщики" && !data.tariff.sign_internal_turnover) {
    data.tariff.revenue = false;
  }
  if ((data.tariff.value_group === "Промышленные потребители" || data.tariff.value_group === "УК, ТСЖ, ЖСК"
    || data.tariff.value_group === "Бюджетные организации" || data.tariff.value_group === "Прочие") && !data.tariff.sign_internal_turnover) {
      data.tariff.expenses = false;
  }
}

checkTarget(data: any) {
  if (data.isNew || data.tariff.is_used) return;
  if (data.isSelect) {
    data.isSelect = false;
  } else {
    data.isSelect = true;
  }
}

changeTarget(data: any) {
  if (this.gettedTariffs || this.blockOnChange) {
    return
  }

  if (data.isNew) return;
  const index = this.target_tariffs.indexOf(data.tariff);
  if (data.isSelect) {
      this.target_tariffs.push(data.tariff);
  } else {
      this.target_tariffs.splice(index, 1);
  }
}

checkNewTariff(data: any) {
  if (data.isNew === false && this.newTarrifCount > 0) {
    confirm('Вы хотите отменить изменения. Отменить?', 'Отмена')
        .then((answer: boolean) => {
          if (answer) {
            this.tariffs.shift();
            this.tariffsData.shift();
            this.tariffsDataMirror.shift();
            this.newTarrifCount -= 1;
          }
        });
  }
}

  haveEditData() {
  if (this.current_node && this.current_cut) {
    // Проверяем как обычные изменения, так и новые тарифы
    if (this.isChangeData || this.newTarrifCount > 0) {
      const message = this.newTarrifCount > 0 
        ? 'Имеются несохранённые новые тарифы. Сохранить?' 
        : 'Имеются несохранённые изменения. Сохранить?';
      
      confirm(message, 'Сохранение')
        .then((answer: boolean) => {
          if (answer) {
            this.onSave();
          } else {
            this.newTarrifCount = 0;
            this.loadTariffData();
          }
        });
    }
  }
}


  focusInNumberBox(data: any, e: any) {
    data.isFocus = true;
    let inputEl = e.element.querySelector(".dx-texteditor-input");
    Vue.nextTick(() => {
      inputEl.selectionStart = 0;
      inputEl.selectionEnd = inputEl.value.length;
    })
  }

  focusOutNumberBox(data:any) {
    data.isFocus = false;
  }

  correctFormat(e:any) {
    let inputEl = e.element.querySelector(".dx-texteditor-input");
    inputEl.addEventListener('paste', (event:any) => {
      event.preventDefault();
      //@ts-ignore
      let paste = (event.clipboardData || window.clipboardData).getData('text');
      paste = paste.replace(".", ",");
      inputEl.value = paste;
    })
  }

changeIndicators(data: any, idx: any, type: string, isPower: boolean = false) {
  if (this.blockCalc) {
    return;
  }
  this.setBlock();
  data.isEdit = true;
  const updateTariffValue = (currentTariff: any, dictKey: string): void => {
    if (!currentTariff) {
      return;
    }

    for (let i = idx; i < this.warmEnergyArray.length; i++) {
      const month = this.warmEnergyArray[i][dictKey].split("_");
      const accepted = data.tariff?.is_accepted?.includes(months_map[month])
      data.tariff.edit_fields.te.add(month);
      if (!accepted && i !== 11 && (!data.tariff[this.warmEnergyArray[i+1][dictKey]] || data.tariff[this.warmEnergyArray[i+1][dictKey]] === currentTariff[this.warmEnergyArray[i][dictKey]])) {
        if (!data.tariff?.is_accepted?.includes(months_map[month]+1)) {
          data.tariff[this.warmEnergyArray[i+1][dictKey]] = data.tariff[this.warmEnergyArray[i][dictKey]];
        }
        currentTariff[this.warmEnergyArray[i][dictKey]] = data.tariff[this.warmEnergyArray[i][dictKey]];
      } else {
        const ending = isPower ? '_wp' : '_we';
        this.countIndex(data, ending);
        currentTariff[this.warmEnergyArray[i][dictKey]] = data.tariff[this.warmEnergyArray[i][dictKey]];
        break;
      }
    }
  };

  let currentTariff: any = null;
  if (data.isNew)  {
    currentTariff = this.tariffsData.find((t:any) => data.tempUuid === t.tempUuid)
  } else {
    currentTariff = this.tariffs.find((t:Tariff) => data.tariff.id === t.id)
  }
  if (!currentTariff) {
    return;
  }

  const dictTariffKey = isPower ? 'tariff_wp' : 'tariff';
  const dictIndexfKey = isPower ? 'index_wp' : 'index';

  switch (type) {
    case 'tariff':
      updateTariffValue(currentTariff, dictTariffKey);
      break;
    case 'index':
      data.tariff[this.warmEnergyArray[idx][dictTariffKey]] = data.tariff[this.warmEnergyArray[idx - 1][dictTariffKey]] * data.tariff[this.warmEnergyArray[idx][dictIndexfKey]];
      updateTariffValue(currentTariff, dictTariffKey);
      break;
  }

  this.unBlock();
}

private countIndex(data: any, ending: string) {
  let previous: string = '';
  for (let p of periods) {
    if (p === 'january') {
      previous = 'january';
      continue
    }

    let val = data.tariff[`${p}${ending}`] / data.tariff[`${previous}${ending}`];
    if (_.isNaN(val) || val === Infinity) {
      val = 0;
    }

    data.tariff[`index_${p}${ending}`] = val;
    previous = p;

  }
}

saveFilters() {
  this.saved_filters.year_id = this.current_year;
  this.saved_filters.cut_id = this.current_cut;
  this.saved_filters.filial_id = this.current_filial;
  this.saved_filters.heat_node_id = this.current_node;

  localStorage.setItem(`${this.auth_service.getUserId()}_${this.ls_key}`, JSON.stringify(this.saved_filters));
}

loadFilters() {
  const saved = localStorage.getItem(`${this.auth_service.getUserId()}_${this.ls_key}`);
  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      this.saved_filters = _.clone(parsed);

    } catch (e) {
      //
    }
  }
}

replaceInput(index: number, key_: string) {
  this.tariffsDataMirror[index].inputsReady[key_] = true;
  this.$forceUpdate();
}

replaceSpan(index: number, key_: string){
  this.tariffsDataMirror[index].inputsReady[key_] = false;
  this.$forceUpdate();
}

rounding(data: number, is_accepted: boolean) {
  if (is_accepted) return "Тариф используется в акцептированных записях"
  if (data) return +data.toFixed(2)
  return '';
}

private destroyed(): void {
  if (this.$options.sockets) {
    delete this.$options.sockets.onmessage;
  }
}

// Методы для Excel paste функциональности
hideExcelHint() {
  this.showExcelHint = false;
}

// Метод для обработки запросов на вставку от дочерних компонентов
handlePasteRequest(pasteInfo: any) {
  console.log('Получен запрос на вставку:', pasteInfo);

  const { matrix, tariffIndex, startRow, startCol } = pasteInfo;

  // Определяем, нужно ли распространить вставку на другие тарифы
  const rows = matrix.length;
  const cols = matrix?.length || 0;
  const shouldSpreadToOtherTariffs = (rows > 0 || cols > 0);

  if (shouldSpreadToOtherTariffs) {
    // Устанавливаем глобальные параметры вставки
    this.globalPasteData = matrix;
    this.globalPasteStartRow = startRow;
    this.globalPasteStartCol = startCol;
    this.globalPasteTargetTariff = tariffIndex;

    // Применяем вставку ко всем подходящим тарифам
    this.applyGlobalPaste();
  }
}

// Метод для применения глобальной вставки
applyGlobalPaste() {
  if (!this.globalPasteData || this.globalPasteTargetTariff === null) {
    return;
  }

  console.log(`Применение глобальной вставки: ${this.globalPasteData.length}x${this.globalPasteData?.length || 0}`);

  // Применяем матричную вставку
  this.applyMatrixGlobalPaste();

  // Очищаем глобальные параметры вставки
  this.clearGlobalPaste();
}

// Метод для применения значения к конкретному тарифу и месяцу
applyValueToTariffMonth(tariffIndex: number, monthIndex: number, value: number) {
  if (!this.tariffsData[tariffIndex]) {
    return;
  }

  const tariff = this.tariffsData[tariffIndex].tariff;
  const month = this.warmEnergyArray[monthIndex];

  if (month && typeof value === 'number' && !isNaN(value) && isFinite(value)) {
    // Применяем значение к тарифу на тепловую энергию
    tariff[month.tariff] = value;
    console.log(`Применено значение ${value} к тарифу ${tariffIndex}, месяц ${monthIndex}, поле ${month.tariff}`);
  } else {
    console.log(`Некорректное значение ${value} для тарифа ${tariffIndex}, месяц ${monthIndex}`);
  }
}

// Метод для матричной вставки (несколько строк и столбцов)
applyMatrixGlobalPaste() {
  if (!this.globalPasteData) return;

  const rows = this.globalPasteData.length;
  const cols = this.globalPasteData[0]?.length || 0;

  console.log(`Матричная вставка: ${rows}x${cols} начиная с позиции (${this.globalPasteStartRow}, ${this.globalPasteStartCol})`);

  // Интерпретируем матрицу: строки = месяцы, столбцы = тарифы
  for (let rowIndex = 0; rowIndex < rows; rowIndex++) {
    const targetTariffIndex = this.globalPasteTargetTariff! + rowIndex;
    const row = this.globalPasteData[rowIndex];

    // console.log(`Обработка строки ${rowIndex}: месяц ${targetMonthIndex}, значения [${row.join(', ')}]`);

    for (let colIndex = 0; colIndex < cols; colIndex++) {
    const targetMonthIndex = this.globalPasteStartRow + colIndex;
      const value = row[colIndex];

      if (targetTariffIndex >= 0 && targetTariffIndex < this.tariffsData.length) {
        console.log(`  Столбец ${colIndex}: тариф ${targetTariffIndex}, значение ${value}`);

        // Применяем значение к соответствующему тарифу и месяцу
        this.applyValueToTariffMonth(targetTariffIndex, targetMonthIndex, value);
      } else {
        console.log(`  Столбец ${colIndex}: тариф с индексом ${targetTariffIndex} не найден`);
      }
    }
  }
}

// Метод для очистки глобальных параметров вставки
clearGlobalPaste() {
  this.globalPasteData = null;
  this.globalPasteStartRow = 0;
  this.globalPasteStartCol = 0;
  this.globalPasteTargetTariff = null;
}

// Метод для обработки Excel paste событий
onExcelPaste(event: any, tariffIndex: number, monthIndex: number, fieldType: string) {
  console.log(`Excel paste в тарифе ${tariffIndex}, месяц ${monthIndex}, поле ${fieldType}`);

  // Парсим данные из буфера обмена
  const clipboardData = event.clipboardData || (window as any).clipboardData;
  const pastedData = clipboardData.getData('text');

  if (!pastedData) {
    return;
  }

  // Парсим данные в матрицу
  const matrix = this.parseClipboardData(pastedData);

  if (matrix.length === 0) {
    return;
  }

  console.log('Распарсенные данные:', matrix);

  // Определяем, нужно ли показать подсказку
  const rows = matrix.length;
  const cols = matrix?.length || 0;

  if (rows > 0 || cols > 0) {
    this.showExcelHint = true;
  }

  // Отправляем запрос на вставку
  this.handlePasteRequest({
    matrix,
    tariffIndex,
    startRow: monthIndex,
    startCol: 0
  });
}

// Метод для парсинга данных из буфера обмена
parseClipboardData(data: string): number[][] {
  const lines = data.trim().split('\n');
  const matrix: number[][] = [];

  for (const line of lines) {
    const values = line.split('\t');
    const row: number[] = [];

    for (const value of values) {
      const trimmedValue = value.trim();
      if (trimmedValue === '') {
        row.push(0);
      } else {
        const numValue = parseFloat(trimmedValue.replace(',', '.'));
        row.push(isNaN(numValue) ? 0 : numValue);
      }
    }

    if (row.length > 0) {
      matrix.push(row);
    }
  }

  return matrix;
}
}
